import React from 'react'
import { Row, FormInput, Widget } from '@digital/ui'
import { Collapse, Icon } from 'antd';
import ptBR from '@app/i18n/ptBR'
import { aprovacoesSolicitacaoState } from '../../../atoms';
import { useRecoilValue } from 'recoil';

const { Panel } = Collapse;

const ValidacoesAprovacoes = () => {
    const aprovacoes = useRecoilValue(aprovacoesSolicitacaoState);

    return (
        <>
            <Collapse
                bordered={false}
                defaultActiveKey={['2']}
                expandIcon={() => <Icon type="arrows-right_4" />}>
                <Panel key="2"
                    header={ptBR.lblValidacoesEAprovacoes} style={{ border: 0 }}>
                    <Widget
                        title=""
                        actions={[]}>
                        <>
                            {
                                aprovacoes.length > 0 && (
                                    <>
                                        {
                                            aprovacoes.map((aprovacao, index) => {
                                                return (
                                                    <fieldset key={aprovacao.id}>
                                                        <legend className='legend-float-left'>{aprovacao.tipoAprovacaoSolicitacaoNaoPrevistoNome}</legend>

                                                        <Row>
                                                            <FormInput
                                                                span={3}
                                                                name='nomeAprovador'
                                                                label={ptBR.lblNome}
                                                                disabled
                                                                value={aprovacao.aprovador}
                                                            />

                                                            <FormInput
                                                                span={3}
                                                                name='funcaoAprovador'
                                                                label={ptBR.lblFuncao}
                                                                disabled
                                                                value={aprovacao.aprovadorFuncao}
                                                            />

                                                            <FormInput
                                                                span={3}
                                                                name='departamentoAreaDiretoria'
                                                                label={ptBR.lblDiretoriaAreaDepartamento}
                                                                disabled
                                                                value={aprovacao.aprovadorDiretoriaAreaDepartamento} />

                                                            <FormInput
                                                                span={3}
                                                                name='status'
                                                                label={ptBR.status}
                                                                disabled
                                                                value={aprovacao.statusAprovacaoSolicitacaoNaoPrevistoNome} />
                                                        </Row>
                                                    </fieldset>
                                                )
                                            })
                                        }
                                    </>
                                )
                            }
                        </>
                    </Widget>

                </Panel>
            </Collapse>
        </>
    )
}

export default ValidacoesAprovacoes